export enum BitmojiAppSnapchatUpsellTypeEnum {
  BUILDER_TAB_BANNER = 'BUILDER_TAB_BANNER',
  AVATAR_TAB_BANNER = 'AVATAR_TAB_BANNER',
  BUILDER_TAB_DEPRECATION_BANNER = 'BUILDER_TAB_DEPRECATION_BANNER',
  AVATAR_TAB_DEPRECATION_BANNER = 'AVATAR_TAB_DEPRECATION_BANNER',
}
